import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { SelectItem } from 'primereact/selectitem';
import { Labelled, LabelledProps } from './Labelled';

interface LabelledDropdownProps extends LabelledProps {
  value: any;
  onChange: (value: any) => void;
  options: SelectItem[];
  autoFocus?: boolean;
  className?: string;
  appendTo?: 'self' | HTMLElement | undefined | null | (() => HTMLElement);
  emptyMessage?: ReactNode | string;
  filter?: boolean;
  onShow?: () => void;
  isNew?: boolean;
}

export const LabelledDropdown = (props: LabelledDropdownProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <Dropdown
        id={props.id}
        appendTo={props.appendTo}
        value={props.value}
        required={props.permissions?.required || props.required}
        invalid={props.validation && !props.validation?.valid}
        disabled={disabled}
        options={props.options}
        onChange={(e: DropdownChangeEvent): void => props.onChange(e.target.value)}
        autoFocus={props.autoFocus}
        className={props.className + ` ${props.isNew && props.validation && props.validation?.valid ? 'border-primary-500 border-3' : ''}`}
        filter={props.filter}
        onShow={props.onShow}
        pt={{wrapper: { style: { maxHeight: '300px'}}}}
        showClear={!props.permissions?.required && !props.required}
        emptyMessage={props.emptyMessage}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
      />
    </Labelled>
  );
};
